export default [
  {
    path: '/admin/report/service-requests',
    name: 'service-request',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/service-order/index.vue')
  }
]
